import apiClient from '@u/apiClient'

export default {
  fetchGuestSuite({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`dossier/${payload.dossier_id}/guest-suite`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createGuestSuite({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`dossier/${payload.dossier_id}/guest-suite`, payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateAutoCreate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .put(`dossier/${payload.dossier_id}/guest-suite`, payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
